export const mergeArray = <T>(...list: (T[] | null)[]): T[] => {
  const listTmp = list.filter((subList) => Array.isArray(subList) && !!subList.length) as T[][];
  return listTmp.flat();
};

export const formatTagName = (options?: IGPSelectOption[] | null, optionValue?: string): string => {
  if (!Array.isArray(options) || !options.length) return '';
  if (!optionValue) return '';
  const option = options.find((option) => option?.value === optionValue);
  return option?.label as string;
};

export const formatTagsNames = (options?: IGPSelectOption[] | null): string[] => {
  if (!Array.isArray(options) || !options.length) return [];
  return options.map((option) => option?.label as string);
};
